








import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { replaceString } from '@/common/utils/dealWithString';

@Component
export default class IndexContactInfo extends Vue {
  @Getter("contactInfo")
  getterContactInfo!: string;

  @Getter("section")
  section!: object;
  @Getter("contactQrcode")
  contactQrcode!: string;

  get contactInfo(): string {
    return replaceString(this.getterContactInfo);
  }
}
